import React from 'react'
import { NewButton, Section, StartTrialButtonWithModal } from 'newComponents'
import './styles.scss'

const DemoBanner = ({ startTrial }) => {
  const RenderButton = () => {
    return (
      (startTrial) ? (
        <StartTrialButtonWithModal
          cta="Start Trial"
          classes="button is-large is-primary modal-trigger"
          trackEvent="Start 14-Day Free Trial Button Clicked"
          addArrow
        />
      ) : (
        <NewButton to="/request-a-demo" eventName="Request Demo Button Clicked" className="outline" chevron>
          Get a Demo
        </NewButton>
      )
    )
  }

  return (
    <Section className="new-demo-banner">
      <div className="new-demo-banner-text-container">
        <h3 className="new-demo-banner-text">
          <span>Need help?</span> An expert will be in touch as soon as possible.
        </h3>
      </div>
      <RenderButton />
    </Section>
  )
}
export default DemoBanner
